<template>
	<div class="m-recommend">
		<ul class="tab-list flex">
			<li v-if="unitData.show == 1" class="flex-grow flex-column flex-center z-crt">
				<div>{{unitData.title_text}}</div>
				<p>{{unitData.sub_title}}</p>
			</li>
			<li v-for="(item, i) in unitData.tabs" :key="i" class="flex-grow flex-column flex-center">
				<div>{{item.title_text}}</div>
				<p>{{item.sub_title}}</p>
			</li>
		</ul>
		<div class="product-list">
			<ul>
				<template v-for="(item, i) in unitData.product_list">
					<li :key="item.product_id" class="flex">
						<sub-image class="image" :src="item.product_img_url"></sub-image>
						<div class="info flex-grow">
							<p class="name ellipsis-2">{{item.product_name}}</p>
							<div class="price">￥{{item.price_modue == 2 ? '价格面议' : item.sale_price}}<span v-if="item.price_unit">/{{item.price_unit}}</span></div>
						</div>
					</li>
				</template>
			</ul>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				unitData: {}
			}
		},
		
		mounted() {
		},
		
		methods: {
		}
	}
</script>

<style lang="stylus" scoped>
	.m-recommend {
		padding-bottom: 10px;
		background: #F2F2F2;
			
		.tab-list {
			height: 70px;
			background: #F2F2F2;
			
			li {
				height: 100%;
				
				&.z-crt {
					div, p {
						color: #C70000;
					}
				}
				
				div {
					font-size: 20px;
					font-weight: bold;
				}
				
				p {
					margin-top: 5px;
					font-size: 12px;
					color: #999;
				}
			}
		}
		
		.product-list {
			padding: 0 12px;
			
			ul {
				li {
					border-radius: 6px;
					padding: 12px 10px;
					overflow: hidden;
					background: #fff;
					
					&:nth-child(n+2) {
						margin-top: 10px;
					}
					
					.image {
						width: 106px;
						height: 80px;
					}
					
					.info {
						padding: 5px 11px 0;
						
						.name {
							height: 44px;
							line-height: 22px;
							font-size: 15px;
						}
						
						.price {
							margin-top: 5px;
							font-size: 18px;
							font-weight: bold;
							color: #FF6900;
							
							span {
								margin-left: 3px;
								font-size: 13px;
								font-weight: normal;
							}
						}
					}
				}
			}
		}
	}
</style>
